import { memoize } from 'lodash';

import { MetaOsHubContext, getMetaOsHubContext } from './context';

interface HostMetadata {
  readonly hostSessionId: MetaOsHubContext['app']['sessionId'] | undefined;
  readonly hostAppName: MetaOsHubContext['app']['host']['name'] | undefined;
  readonly hostClientType: MetaOsHubContext['app']['host']['clientType'] | undefined;
}
type GetHostMetadata = () => Promise<HostMetadata>;
export const getHostMetadata: GetHostMetadata = memoize(async () => {
  const context = await getMetaOsHubContext();

  return {
    hostSessionId: context?.app.sessionId,
    hostAppName: context?.app.host.name,
    hostClientType: context?.app.host.clientType,
  };
});
